module.exports = __webpack_public_path__ + "static/media/image13.e44ee1d6.jpg";